import { render } from "./Sagittarius.vue?vue&type=template&id=7e404e01&scoped=true"
import script from "./Sagittarius.vue?vue&type=script&lang=js"
export * from "./Sagittarius.vue?vue&type=script&lang=js"

import "./Sagittarius.vue?vue&type=style&index=0&id=7e404e01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e404e01"]])

export default __exports__